import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { EmailTranscriptActions } from './email-transcript.actions';
import { Store } from '@ngrx/store';
import { EmailTranscriptService } from '../../services/email-transcript.service';
import { selectSessionIdentifier } from '../va-session/va-session.reducer';
import { selectLanguage } from '../settings/settings.reducers';
import { selectChatId } from '../live-chat/live-chat.reducer';
import { selectCustomerName } from '../user-info/user-info.reducer';

@Injectable({
  providedIn: 'root',
})
export class EmailTranscriptEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private emailTranscriptService: EmailTranscriptService
  ) {}

  requestEmailTranscript$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmailTranscriptActions.requestTranscript),
      concatLatestFrom(() => [
        this.store.select(selectSessionIdentifier),
        this.store.select(selectLanguage),
        this.store.select(selectChatId),
        this.store.select(selectCustomerName),
      ]),
      switchMap(([action, sessionId, language, chatId, name]) =>
        this.emailTranscriptService
          .requestEmailTranscript({
            name,
            email: action.email,
            sessionId,
            chatId,
            language,
          })
          .pipe(
            map(() => EmailTranscriptActions.setSubmitted()),
            catchError(() => of(EmailTranscriptActions.setFailed()))
          )
      )
    )
  );
}
